import React, { useState, useEffect } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Box,
} from '@mui/material';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const Modulos = () => {
  const { user: currentUser } = useAuth();
  const [modules, setModules] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedModule, setSelectedModule] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    value: '',
  });

  useEffect(() => {
    fetchModules();
  }, []);

  const fetchModules = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/modules`);
      setModules(response.data);
    } catch (error) {
      console.error('Ha ocurrido un error:', error);
    }
  };

  const handleOpenDialog = (module = null) => {
    if (module) {
      setSelectedModule(module);
      setFormData({
        name: module.name,
        value: module.value,
      });
    } else {
      setSelectedModule(null);
      setFormData({
        name: '',
        value: '',
      });
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedModule(null);
  };

  const handleSubmit = async () => {
    try {
      const submitData = {
        ...formData,
        value: parseFloat(formData.value),
      };

      if (selectedModule) {
        await axios.put(
          `${process.env.REACT_APP_API_URL}/api/modules/${selectedModule.id}`,
          submitData
        );
      } else {
        await axios.post(`${process.env.REACT_APP_API_URL}/api/modules`, submitData);
      }
      fetchModules();
      handleCloseDialog();
    } catch (error) {
      console.error('Ha ocurrido un error:', error);
      alert('Ha ocurrido un error, por favor intenta más tarde nuevamente.');
    }
  };

  const handleDelete = async (moduleId) => {
    if (window.confirm('¿Seguro de eliminar este módulo?')) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_URL}/api/modules/${moduleId}`);
        fetchModules();
      } catch (error) {
        console.error('Ha ocurrido un error:', error);
      alert('Ha ocurrido un error, por favor intenta más tarde nuevamente.');
      }
    }
  };

  const canModifyModule = () => {
    return ['Administrador', 'Sistemas'].includes(currentUser.role);
  };

  return (
    <div>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h4" gutterBottom>
          Módulos
        </Typography>
        {canModifyModule() && (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => handleOpenDialog()}
          >
            Agregar módulo
          </Button>
        )}
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{ whiteSpace: 'nowrap' }}>
              <TableCell>Nombre</TableCell>
              <TableCell>Valor</TableCell>
              <TableCell>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {modules.map((module) => (
              <TableRow key={module.id} sx={{ whiteSpace: 'nowrap' }}>
                <TableCell>{module.name}</TableCell>
                <TableCell>{module.value}</TableCell>
                <TableCell>
                  {canModifyModule() && (
                    <>
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={() => handleOpenDialog(module)}
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        color="error"
                        size="small"
                        onClick={() => handleDelete(module.id)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>
          {selectedModule ? 'Editar módulo' : 'Agregar módulo'}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nombre"
            fullWidth
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Valor"
            type="number"
            fullWidth
            value={formData.value}
            onChange={(e) => setFormData({ ...formData, value: e.target.value })}          
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancelar</Button>
          <Button onClick={handleSubmit} variant="contained">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Modulos;